import { Col, Row } from 'antd';
import React from 'react';

import { useScreenSize } from '../../../hooks';

type DescriptionItemProps = {
  title?: string;
  titleColSizePx?: string;
  content: React.ReactNode;
};

const style = { fontSize: '14px', marginBottom: '7px', color: '#000000a6' };

export function DescriptionItem(props: DescriptionItemProps) {
  const isSmallScreen = useScreenSize();

  if (!props.title) {
    return <Row style={style}>{props.content ?? '-'}</Row>;
  }

  if (isSmallScreen) {
    return <div style={style}>
      <Row style={{ fontWeight: 600 }}>
        {props.title}
      </Row>
      <Row style={{ wordBreak: 'break-word' }}>
        {props.content ?? '-'}
      </Row>
    </div>
  }

  return (
    <Row style={style}>
      <Col flex={`${props.titleColSizePx ?? 150}px`} style={{ fontWeight: 600 }}>
        {props.title}
      </Col>
      <Col style={{ wordBreak: 'break-word' }}>{props.content ?? '-'}</Col>
    </Row>
  );
}
